<template>
    <div class="login2">
        <p class="welcome-text">
            找回用户密码 !
        </p>
        <div class="login2-form">
            <el-form :model="ValidateForm" status-icon ref="ValidateForm" :rules="rules" label-width="100px" class="demo-ruleForm">
                <el-form-item label="请输入邮箱：" prop="email">
                    <el-input type="email" v-model="ValidateForm.email" placeholder="请输入注册时填写的邮箱" @keyup.enter.native="btn_retrieve('ValidateForm')"></el-input>
                </el-form-item>
                <el-form-item label="请输入邮箱：" prop="email" v-show="false">
                    <el-input type="email" v-model="ValidateForm.email" placeholder="请输入注册时填写的邮箱"></el-input>
                </el-form-item>
                <el-form-item>
                    <span class="btn" @click="$router.push({path:'/login'})">登录</span>
                    <span class="btn" @click="$router.push({path:'/register'})">注册</span>
                    <span class="btn" @click="btn_retrieve('ValidateForm')">
                        <i v-if="status">找回密码</i>
                        <i class="el-icon-loading lod" v-else></i>
                    </span>
                </el-form-item>
            </el-form>
        </div>
        <p class="hint">
            如果收不到邮件，请查看是否在垃圾邮件中，
        </p>
        <p class="hint">
            或者将 mylibs@126.com 添加到白名单中即可
        </p>
    </div>
</template>

<script>
    export default {
        // 验证填写的邮箱是否正确
        data() {
            var email_verify = (rule, value, callback) => {
                var emreg=/^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/;
                if(emreg.test(value)==false){
                    callback(new Error('请输入正确的邮箱账号'));
                }else{
                    callback();
                }
            }
            return {
                status: true,
                ValidateForm:{
                    email: ''
                },
                rules: {
                    email: [
                        { type: 'email', validator: email_verify, trigger: 'blur' }
                    ],
                }
            };
        },
        methods: {
            btn_retrieve(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.status = false;
                        let param = new URLSearchParams();
                        param.append("email", this.ValidateForm.email);
                        // 请求数据
                        this.$http.postResetPwd(param).then(response => {
                            // 响应码为200的时候代码成功
                            if (response.code == 200) {
                                this.$message({
                                    message: '发送成功!',
                                    type: 'success',
                                    customClass: 'hint-message',
                                    center: true
                                });
                            // 其它情况
                            }else{
                                this.$message({
                                    message: response.msg,
                                    type: 'warning',
                                    customClass: 'hint-message',
                                    center: true
                                });
                                this.requests_code ()
                            }
                            this.status = true;
                        }).catch(err => {this.status = true;});
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>
<style scoped>
    .login2 {
        width: 1030px;
        margin: 0 auto;
    }

    .welcome-text {
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        padding-top: 5%;
        padding-bottom: 2%;
    }

    .hint {
        text-align: center;
        font-size: 14px;
    }

    .login2-form {
        /* background-color: #efefef; */
        padding: 40px 100px 20px 15px;
        border-radius: 10px;
        width: 400px;
        margin: 0 auto;
        text-align: center;
    }

    .btn {
        height: 28px;
        line-height: 28px;
        color: white;
        border: 0;
        background-color: #A7231E;
        font-weight: bold;
        padding: 5px 10px;
        margin: 0 10px;
    }

    .btn:hover {
        cursor: pointer;
        background-color: rgb(207, 50, 44);
    }
    .lod {
        display: inline-block;
        width: 56px;
    }
</style>